var map = {
	"./ar.gif": "6882",
	"./bn.gif": "3cb3",
	"./br.png": "557e",
	"./cl.gif": "77b8",
	"./co.png": "8e4c",
	"./flb.gif": "fa45",
	"./jp.gif": "db57",
	"./kh.gif": "e475",
	"./kr.gif": "ce26",
	"./la.gif": "2269",
	"./ml.gif": "0785",
	"./mm.gif": "fea0",
	"./mx.png": "d07f",
	"./pe.gif": "ea12",
	"./tg.gif": "97ab",
	"./xjp.gif": "ab72",
	"./yn.gif": "868f",
	"./yuen.gif": "401a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0676";